import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const dummyData = [
  { name: "Jan", total: 300 },
  { name: "Feb", total: 450 },
  { name: "Mar", total: 200 },
  { name: "Apr", total: 500 },
  { name: "Mei", total: 600 },
  { name: "Jun", total: 550 },
];

const Dashboard = () => {
  return (
    <div className="min-h-screen pt-10 pb-10 pl-64 pr-10 text-green-900 bg-green-50">
      <div className="mb-10">
        <h1 className="text-3xl font-bold text-green-800">Dashboard Transaksi Singkong</h1>
        <p className="mt-2 text-green-700">
          Selamat datang kembali 👋. Pantau aktivitas dan perkembangan transaksi singkong hari ini.
        </p>
      </div>

      {/* Info Ringkas */}
      <div className="grid grid-cols-2 gap-6 mb-12 md:grid-cols-4">
        <InfoBox title="Total Transaksi" value="1.230" />
        <InfoBox title="Supplier Aktif" value="87" />
        <InfoBox title="Nota Hari Ini" value="34" />
        <InfoBox title="Total Berat (kg)" value="12.540" />
      </div>

      {/* Grafik */}
      <div className="p-6 mb-12 bg-white shadow rounded-xl">
        <h2 className="mb-4 text-xl font-semibold">Grafik Transaksi Per Bulan</h2>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={dummyData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="total" stroke="#22c55e" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Aktivitas Terbaru */}
      <div className="p-6 bg-white shadow rounded-xl">
        <h2 className="mb-4 text-xl font-semibold">Aktivitas Terbaru</h2>
        <ul className="space-y-3 text-sm">
          <li>📌 Supplier <strong>CV. Maju Jaya</strong> menambahkan transaksi baru - 10.300 kg</li>
          <li>📌 Nota #INV00123 dicetak oleh admin</li>
          <li>📌 Data master singkong diperbarui</li>
          <li>📌 Admin baru ditambahkan: <strong>Rina Oktaviani</strong></li>
        </ul>
      </div>
    </div>
  );
};

const InfoBox = ({ title, value }) => (
  <div className="p-4 text-center bg-green-100 shadow rounded-xl">
    <h3 className="text-sm font-medium text-green-800">{title}</h3>
    <p className="mt-1 text-2xl font-bold text-green-900">{value}</p>
  </div>
);

export default Dashboard;
